<template>
  <div>
    <q-dialog
      :visible.sync="dialogVisible"
      title="新增小件"
      width="300px"
      :innerHeight="100"
      @cancel="updateVal"
      @confirm="confirm"
      @close="updateVal"
    >
      <el-form :model="formData" label-width="100px" :rules="rules" ref="ruleForm" size="mini">
        <el-form-item label="产品编码" prop="productCode">
          <el-input v-model.trim="formData.productCode" placeholder="请输入产品编码" @blur="handleProductBlur"></el-input>
        </el-form-item>
        <el-form-item label="产品名称" prop="productName" class="no-asterrisk">
          {{formData.productName}}
        </el-form-item>
      </el-form>
    </q-dialog>
  </div>
</template>

<script>
import validator from 'validator';
export default {
  model: {
    prop: 'visible',
    event: 'input'
  },
  props: ['visible', 'row'],
  data() {
    return {
      dialogVisible: false,
      formData: {},
      rules: {
        productCode: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        productName: [
          { required: true, message: '产品编码不存在', trigger: 'blur' }
        ]
      }
    }
  },
  mounted() {
    this.dialogVisible = this.visible;
    if(this.row) this.formData = {...this.row};
  },
  methods: {
    updateVal() {
      this.dialogVisible = false;
      setTimeout(_=>{
        this.$emit('input', false)
      },200)
    },
    confirm() {
      this.$refs['ruleForm'].validate(valid=>{
        if(valid) {
          this.submit();
        }else{

        }
      })
    },
    submit() {
      this.$q.preSalePlan.addSmallPiece({data: [this.formData]})
      .then(res=>{
        if(res.code == 200) {
          this.$message.success('新增成功');
        }else{
          this.$message.error(res.message);
        }
      })
      .finally(_=>{
        this.updateVal();
        this.$emit('complete')
      })
    },
    handleProductBlur() {
      if(!this.formData.productCode){
        return
      }
      this.$q.product.getProductForCode({params: { code: this.formData.productCode }})
      .then(res=>{
        if(res.code == 200) {
          this.$set(this.formData, 'productName', res.data[0].name)
        }else{
          this.$message.error(res.message);
        }
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
  .no-asterrisk
    >>> .el-form-item__label
      &::before
        display none
</style>